/**
 * @description 日历奖励
 */

import { RewardStatusEnum, RewardTypeEnum } from "@/types/reward";
import { RewardIcon } from "./reward-icon";
import { Button } from "@/components/ui/button";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useRewardCountDown } from "@/features/reward/hooks/useRewardCountDown";
import { useTranslations } from "next-intl";
import cn from "@/utils/classnames";
import { useClaimDebounce } from "./use-claim-debounce";

interface CalenderRewardProps {
  status: RewardStatusEnum;
  countdown?: number; // 秒
  next_distributed_at?: number; // 秒
  amount: number;
  currency: string;
  claimCurrency: string;
  claimAmount: number;
  bonusWagerMultiple?: string;
  calendarAmount?: number;
  onClaim: () => Promise<unknown>;
  onTimeOut?: () => unknown;
}

export const CalenderReward = (props: CalenderRewardProps) => {
  const { status, next_distributed_at, amount, currency, onClaim, onTimeOut } = props;
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t = useTranslations('reward');
  const { loading, run } = useClaimDebounce(onClaim);

  const { countdownStr, isOverOneDay } = useRewardCountDown({ targetDate: Number(next_distributed_at) * 1000, onEnd: onTimeOut });

  if (![RewardStatusEnum.NO_REWARD, RewardStatusEnum.PROGRESS, RewardStatusEnum.COUNT_DOWN, RewardStatusEnum.CLAIM].includes(status)) {
    return null;
  }

  const handleClaim = async () => {
    return run();
  };

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between"
      style={{
        background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)',
      }}
    >
      <RewardIcon type={RewardTypeEnum.CALENDAR_REWARD} className="mr-2.5" />
      <div className="flex-1 text-xs font-medium leading-3 flex flex-col">
        <div className="text-white">{t('calendarReward')}</div>
        {!!amount && <div className="text-[#FFC600] text-xss mt-3 font-medium">{formatCurrencyDetail(amount)} {currency}</div>}
      </div>
      {
        status === RewardStatusEnum.CLAIM ? <Button
          variant="success"
          size='sm'
          className="w-[90px]"
          disabled={loading}
          loading={loading}
          onClick={handleClaim}>
          {t('claim')}
        </Button> : (
          <Button
            disabled={[RewardStatusEnum.NO_REWARD, RewardStatusEnum.PROGRESS].includes(status)}
            variant='cancel'
            size='sm'
            className={cn("font-medium text-[13px]", [RewardStatusEnum.COUNT_DOWN, RewardStatusEnum.NO_REWARD].includes(status) ? ' text-[#7A879A]  px-[10px] bg-[rgba(47,56,78,0.2)] disabled:opacity-1' : 'w-[90px] text-ss')}>
            {status === RewardStatusEnum.NO_REWARD && t('noRewards')}
            {status === RewardStatusEnum.COUNT_DOWN && <span className={`text-left ${isOverOneDay ? 'w-[71px]' : 'w-[70px] pl-[10px]'}`}>{countdownStr}</span>}
          </Button>
        )
      }
    </div>
  );
};
